import './ModalTelegram.css';

const ModalTelegram = () => {

  return (
    <div className="modal-telegram__container">
      <p >
        Есть вопросы? Пишите в Телеграме!
        <br />
        <a
          href="https://telegram.me/turner_cola"
          target="_blank"
          rel="noreferrer"
        >
          <span>@turner_cola</span>
        </a>
      </p>
    </div>
  );
};

export default ModalTelegram;
